exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".driver-selection[data-v-30eff027] {\n  margin-top: 20px;\n  max-width: 300px;\n}\n\n/* Fix for dropdown text visibility */\n[data-v-30eff027] .md-select .md-select-value {\n  color: #000 !important;\n}\n[data-v-30eff027] .md-select .md-menu-content .md-list-item-content {\n  color: #000 !important;\n}\n[data-v-30eff027] .md-input {\n  -webkit-text-fill-color: #000 !important;\n}\n[data-v-30eff027] .md-menu-content .md-list .md-list-item-content {\n  color: #000 !important;\n}\n", ""]);

// exports
